module.exports = __webpack_public_path__ + "static/assets/3de10b37395b518ce870c9a6478f4c42.png";